import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const SET_CURRENT_NEWS = "SET_CURRENT_NEWS";
